import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CurrencyPipe } from '@angular/common';

import { DlgWalrusModule } from 'dlg-walrus';

import { SharedServicesModule } from '@app/shared/services/shared-services.module';
import { SharedFeaturesModule } from '@global/shared-features/shared-features.module';

import { DirectDebitTableComponent } from '@app/shared/components/direct-debit-table/direct-debit-table.component';
import { ErrorComponent } from '@app/shared/components/errors/error/error.component';
import { SaveModalComponent } from '@app/shared/components/modals/save-modal/save-modal.component';
import { SectionHeadingComponent } from './components/section-heading/section-heading.component';
import { InLineErrorComponent } from './components/errors/in-line-error/in-line-error.component';
import { PromoCodeErrorComponent } from './components/errors/promo-code-error/promo-code-error.component';
import { DrivingLicenseNumberComponent } from '@app/features/your-drivers/components/manage/driving-license-number/driving-license-number.component';
import { LicenceModalComponent } from '@app/features/your-drivers/modals/licence-modal.component';

import { TextSpacePipe } from '@app/shared/pipes/text-space.pipe';
import { SortCodePipe } from '@app/shared/pipes/sort-code.pipe';
import { MaskValuePipe } from '@app/shared/pipes/mask-value.pipe';
import { OrdinalNumberPipe } from '@app/shared/pipes/ordinal-number.pipe';
import { SingleAlertComponent } from '@global/shared-features/single-alert/single-alert.component';

@NgModule({
  declarations: [
    TextSpacePipe,
    SortCodePipe,
    MaskValuePipe,
    OrdinalNumberPipe,
    DirectDebitTableComponent,
    ErrorComponent,
    SaveModalComponent,
    SectionHeadingComponent,
    InLineErrorComponent,
    PromoCodeErrorComponent,
    DrivingLicenseNumberComponent,
    LicenceModalComponent,
  ],
  imports: [
    DlgWalrusModule,
    CommonModule,
    SharedFeaturesModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DlgWalrusModule,
    SharedServicesModule,
    SharedFeaturesModule,
    TextSpacePipe,
    SortCodePipe,
    MaskValuePipe,
    SingleAlertComponent,
    OrdinalNumberPipe,
    DirectDebitTableComponent,
    ErrorComponent,
    SaveModalComponent,
    SectionHeadingComponent,
    InLineErrorComponent,
    PromoCodeErrorComponent,
    DrivingLicenseNumberComponent,
  ],
  entryComponents: [
    SaveModalComponent,
    LicenceModalComponent
  ],
  providers: [
    CurrencyPipe
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }
